module.exports = __webpack_public_path__ + "assets/img/tab2_03.29bf4b92.jpg";